export var RequestKind;
(function (RequestKind) {
    RequestKind["INIT"] = "INIT";
    RequestKind["CHANGE_COUNTRY"] = "CHANGE_COUNTRY";
    RequestKind["CHANGE_LOCATION"] = "CHANGE_LOCATION";
    RequestKind["CHANGE_TITLE"] = "CHANGE_TITLE";
})(RequestKind || (RequestKind = {}));
export var EventKind;
(function (EventKind) {
    EventKind["INIT"] = "INIT";
    EventKind["COUNTRY_CHANGE"] = "COUNTRY_CHANGE";
    EventKind["LOCATION_CHANGE"] = "LOCATION_CHANGE";
    EventKind["LOCALE_CHANGE"] = "LOCALE_CHANGE";
    EventKind["CTA_BUTTON_CLICKED"] = "CTA_BUTTON_CLICKED";
})(EventKind || (EventKind = {}));
export var CountryCode;
(function (CountryCode) {
    CountryCode["GERMANY"] = "DE";
    CountryCode["SPAIN"] = "ES";
    CountryCode["GEORGIA"] = "GE";
    CountryCode["CROATIA"] = "HR";
    CountryCode["MONTENEGRO"] = "ME";
    CountryCode["NETHERLANDS"] = "NL";
    CountryCode["POLAND"] = "PL";
    CountryCode["TURKEY"] = "TR";
    CountryCode["UZBEKISTAN"] = "UZ";
    CountryCode["COLOMBIA"] = "CO";
    CountryCode["LITHUANIA"] = "LT";
    CountryCode["MEXICO"] = "MX";
    CountryCode["UKRAINE"] = "UA";
    CountryCode["KAZAKHSTAN"] = "KZ";
    CountryCode["SERBIA"] = "RS";
    CountryCode["ARMENIA"] = "AM";
    CountryCode["INDIA"] = "IN";
})(CountryCode || (CountryCode = {}));
export var MapLayer;
(function (MapLayer) {
    MapLayer["openStreetMap"] = "OpenStreetMap";
    MapLayer["googleMaps"] = "Google Maps";
    MapLayer["googleMapsSatellite"] = "Google Maps (Satellite)";
})(MapLayer || (MapLayer = {}));
